import { render, staticRenderFns } from "./SideBarTabComments.vue?vue&type=template&id=7d5c3a72&"
import script from "./SideBarTabComments.vue?vue&type=script&lang=js&"
export * from "./SideBarTabComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports